/**
 * @generated SignedSource<<e35df02f8cc2a608c746cff890a96d4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UJStatuses = "OBSOLETE" | "PAUSED" | "RUNNING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettings_statusFragment$data = {
  readonly id: string;
  readonly status: UJStatuses;
  readonly " $fragmentType": "selfServiceSettings_statusFragment";
};
export type selfServiceSettings_statusFragment$key = {
  readonly " $data"?: selfServiceSettings_statusFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_statusFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "selfServiceSettings_statusFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "42e2fd4cc6159e05cb15c594673d6a4e";

export default node;
